<div class="map" #bingMap>
    @if (!isLoading && showNoDataMessage) {
<div class="message">{{localize(langSection.OnProperty, langText.NoDataForLocation)}}</div>
}
    @if (isLoading) {
<div class="message">{{localize(langSection.Term, langText.Loading)}}</div>
}
</div>
